import { render } from "./AboutStyleOne.vue?vue&type=template&id=45795d19"
import script from "./AboutStyleOne.vue?vue&type=script&lang=js"
export * from "./AboutStyleOne.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__